"use client"
import React from 'react';
import {WidgetProps} from './component/widgetTitleBar';
import {Column} from "@/core/general/column.component";
import {Row} from "@/core/general/row.component";
import {getIconColor} from "@/core/shortcut/utils/shortcut.utils";
import ToolsShortcutContainerComponent from "@/core/widget/shortcut/toolsShortcutContainer.component";
import {useTranslations} from "use-intl";
import Image from "next/image"

export default function SearchComponent(props: WidgetProps) {
    const t = useTranslations()
    return (
        <Column className="totalCenter w-full">
            <Row className="flex-wrap px-2 w-full center overflow-y-scroll hideScrollBar">
                {props.widget.shortcuts?.map((item, index) => (
                    <Column key={index}
                            className={`w-1/4 sm:w-auto px-3 py-2 center relative cursor-pointer ${(item.is_enabled ?? true) ? "" : "opacity-50"}`}>
                        {item.icon_url?.includes("http") ?
                            <Image fill={true} style={{backgroundColor: getIconColor(item.icon_color)}}
                                   src={item.icon_url}
                                   className={"!relative w-full sm:!w-20 !aspect-square w-full !rounded-xl"}
                                   alt={""}/>
                            :
                            <Image fill={true} style={{backgroundColor: getIconColor(item.icon_color)}}
                                   src={`/image/png_ic_${item.unique_name}.png`}
                                   className={"!relative w-full sm:!w-20 !aspect-square w-full !rounded-xl"}
                                   alt={""}/>
                        }
                        <div
                            className={"text-sm h-6 mt-2 text-center w-full sm:!w-20 truncate mText"}>{item.title?.fa ?? t(`shName.${item.unique_name}`)}</div>
                        <ToolsShortcutContainerComponent shortcut={item}/>
                    </Column>
                ))}
            </Row>
        </Column>
    );
};
